import React from 'react';

import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';

// Using this to take screenshot of current view since there are too many cross browser issues with rendering html inside canvas
// Note that currently svgs don't work with this library (or any others potentially?) so the app select, weather icons, and reports won't show properly
import html2canvas from 'html2canvas';

import events from '../../../lib/events.js';
import {getInfo} from 'services/testConnect';
import SupportApi from '../../../api/support.jsx';
import session from '../../../services/sessionService.jsx';

import Modal from './modal.jsx';

import LayoutImageSelect from '../forms/LayoutImageSelect.jsx';
import LayoutInput from '../forms/layoutInput.jsx';
import LayoutSelect from '../forms/LayoutSelect.jsx';
import LayoutTextArea from '../forms/LayoutTextArea.jsx';
import LayoutCheckbox from '../forms/layoutCheckbox.jsx';
import LoadingBtn from '../loadingBtn.jsx';

import ValidationGroup, {isValidEmail, isValidPhone} from '../../helpers/validation.js';
import phoneFormat from '../../helpers/phoneFormat.js';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class BugReportModal extends React.PureComponent {
  static displayName = 'BugReportModal';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);


    let branches = session.getMyBranches();

    this.state = cloneDeep(this.defaultState);
    this.state.selectedBranch = branches.length > 0 ? branches[0].id : null;
  }

  componentWillMount() {
    let func = debounce(this._submit, 500, {leading: true, trailing: false});

    this.group = new ValidationGroup(func);

    this.listener = events.subscribe('bug-report', () => {
      html2canvas(document.body, {useCors: true, background: '#fff'}) // Won't draw borders without cors for some reason
        .then(canvas => {
          let sizedCanvas = document.createElement('canvas');

          sizedCanvas.style['background-color'] = '#fff';
          let sCtx = sizedCanvas.getContext('2d'); // Copy it onto a second, smaller canvas so that it hides the out of view area

          sCtx.fillStyle = '#fff';
          sizedCanvas.width = window.innerWidth;
          sizedCanvas.height = window.innerHeight;

          sCtx.drawImage(canvas, 0, 0);
          this.setState({canvas: sizedCanvas});
        })
        .catch(err => {
          console.error(err);
        });

      let report = Object.assign({}, this.state.report);

      report.url = location.href;

      this.setState({
        visible: true,
        report,
      });
    });
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.visible && this.state.visible) {
      this.getSystemInfo();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.listener) {
      this.listener.remove();
    }
  }

  get defaultState() {
    return {
      canvas: null,
      submitting: false,
      report: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        url: '',
        description: '',
        image: null,
        supportType: '1',
        systemName: null,
        systemVersion: null,
        OSVersion: null,
        systemID: null,
        includeLogs: true,
      },
      visible: false,
    };
  }

  getSystemInfo = () => {
    getInfo()
      .then(data => {
        if (!data || !data.info) {
          this.setState({
            report: {
              ...this.state.report,
              systemName: data.name,
              systemVersion: data.version,
              OSVersion: data.OSVersion,
              systemID: data.systemID,
            },
          });
        }
      })
      .catch(e => {
        console.log('err', e);
      });
  };


  close = () => {
    this.setState(cloneDeep(this.defaultState));
  };


  _submit = () => {
    let {name, email, phone, store, subject, url, description, supportType, systemName, systemVersion, includeLogs, OSVersion, systemID} = this.state.report;

    this.setState({
      submitting: true,
    });

    SupportApi.contact(supportType, name, email, phone, store, subject, description,
      url, this.image && this.image.getImage ? this.image.getImage() : undefined, systemName, systemVersion, OSVersion, systemID, includeLogs)
      .then(x => {
        if (this.mounted) {
          this.close();
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({
          submitting: false,
        });
      });
  };

  update = (e) => {
    if (e && e.key) {
      let report = Object.assign({}, this.state.report);

      report[e.key] = e.value;
      this.setState({report});
    }
  };

  render() {
    if (!this.state.visible) {
      return null;
    }

    let {report} = this.state;
    let {formatMessage} = this.props.intl;
    let branches = session.getMyBranches();
    let branchKeys = branches.map(x => x.name);
    let branchValues = branches.map(x => x.name);

    branchKeys.unshift('');
    branchValues.unshift(formatMessage({id: 'general.select.store'}));

    return <Modal onClose={this.close}
                  width={700}>
      <div className='bug-report-modal'>
        <h1><FormattedMessage id='problem.report.title'/></h1>
        <h2 className='small'><FormattedMessage id='problem.report.description'/></h2>

        <h2 className='with-keyline'><FormattedMessage id='problem.report.contact.information'/></h2>
        <div className='row'>
          <div className='col-md-6'>
            <LayoutInput label={formatMessage({id: 'customer.name'})}
                         editMode={true}
                         required={true}
                         group={this.group}
                         value={report.name}
                         dataKey='name'
                         dataChanged={this.update}/>
          </div>
          <div className='col-md-6'>
            <LayoutInput label={formatMessage({id: 'general.email'})}
                         editMode={true}
                         required={true}
                         group={this.group}
                         validate={isValidEmail}
                         value={report.email}
                         dataKey='email'
                         dataChanged={this.update}/>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <LayoutInput label={formatMessage({id: 'general.phone.number'})}
                         editMode={true}
                         required={true}
                         group={this.group}
                         validate={isValidPhone}
                         value={report.phone}
                         dataKey='phone'
                         dataChanged={this.update}
                         format={phoneFormat}/>
          </div>
          <div className='col-md-6'>
            <LayoutSelect
              keys={branchKeys}
              options={branchValues}
              editMode={true}
              label={formatMessage({id: 'general.store'})}
              dataKey='store'
              dataChanged={this.update}
              value={report.store}
              group={this.group}
              required={true}
            />
          </div>
        </div>

        <div className='row'>
          <div className='col-md-6'>
            <LayoutCheckbox editMode={true}
                            label={formatMessage({id: 'problem.report.system.info'})}
                            value={report.includeLogs}
                            dataChanged={this.update}
                            dataKey='includeLogs'/>
          </div>
        </div>

        <h2 className='with-keyline'><FormattedMessage id='problem.report.decribe.request'/></h2>
        <div className='row'>
          <div className='col-md-6'>
            <LayoutInput label={formatMessage({id: 'problem.report.subject.line'})}
                         type='text'
                         editMode={true}
                         required={true}
                         group={this.group}
                         value={report.subject}
                         dataKey='subject'
                         dataChanged={this.update}/>
          </div>
          <div className='col-md-6'>
            <LayoutInput label={formatMessage({id: 'problem.report.relevant.url'})}
                         type='text'
                         editMode={true}
                         required={true}
                         group={this.group}
                         value={report.url}
                         dataKey='url'
                         dataChanged={this.update}/>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <LayoutTextArea label={formatMessage({id: 'general.description'})}
                            required={true}
                            rows={9}
                            editMode={true}
                            group={this.group}
                            value={report.description}
                            dataKey='description'
                            onChange={this.update}/>
          </div>
          <div className='col-md-6'>
            <LayoutImageSelect label={formatMessage({id: 'general.screenshot'})}
                               edit={true}
                               ref={r => this.image = r}
                               image={this.state.canvas ? this.state.canvas.toDataURL() : null}/>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='pull-right'>
              <button className='btn btn-default'
                      onClick={this.close}
                      style={{marginRight: 15}}><FormattedMessage id='general.cancel'/></button>
              <LoadingBtn loading={this.state.submitting}
                          className='btn btn-primary'
                          onClick={this.group.validate}><FormattedMessage id='general.submit'/></LoadingBtn>
            </div>
          </div>
        </div>
      </div>
    </Modal>;
  }
}

export default injectIntl(BugReportModal);
